import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Img1 from "../assets/images/gallery/1.jpg";
import Img4 from "../assets/images/gallery/4.jpg";
import Img5 from "../assets/images/gallery/5.jpg";
import Img9 from "../assets/images/gallery/9.jpg";
import Img10 from "../assets/images/gallery/10.jpg";
import Img12 from "../assets/images/gallery/12.jpg";
import Img13 from "../assets/images/gallery/13.jpg";
import Img16 from "../assets/images/gallery/16.jpg";
import Img20 from "../assets/images/gallery/20.jpg";
import Img27 from "../assets/images/gallery/27.jpg";
import Img28 from "../assets/images/gallery/28.jpg";
import Img30 from "../assets/images/gallery/30.jpg";
import Img31 from "../assets/images/gallery/31.png";
import Img32 from "../assets/images/gallery/32.png";
import Img33 from "../assets/images/gallery/33.png";
import Img34 from "../assets/images/gallery/34.jpg";
import Img35 from "../assets/images/gallery/35.jpg";
import Img36 from "../assets/images/gallery/36.jpg";
import Img37 from "../assets/images/gallery/37.jpg";
import Img38 from "../assets/images/gallery/38.jpg";

export default function Gallery() {
    const { t } = useTranslation();
    const [selectedCategory, setSelectedCategory] = useState('Todas');

    const rawCategories = ['Todas', 'Interior', 'Exterior', 'Fachadas', 'Piscinas'];
    const categories = rawCategories.map(cat => ({
        key: cat,
        label: t(cat)
    }));

    const images = [
        { id: 1, src: Img1, category: 'Interior', labelKey: t('label1') },
        { id: 2, src: Img20, category: 'Interior', labelKey: t('label2') },
        { id: 3, src: Img4, category: 'Interior', labelKey: t('label3') },
        { id: 4, src: Img34, category: 'Interior', labelKey: t('label4') },
        { id: 5, src: Img13, category: 'Interior', labelKey: t('label5') },
        { id: 6, src: Img10, category: 'Exterior', labelKey: t('label6') },
        { id: 7, src: Img35, category: 'Exterior', labelKey: t('label7') },
        { id: 8, src: Img37, category: 'Exterior', labelKey: t('label8') },
        { id: 9, src: Img9, category: 'Exterior', labelKey: t('label9') },
        { id: 10, src: Img36, category: 'Exterior', labelKey: t('label10') },
        { id: 11, src: Img30, category: 'Fachadas', labelKey: t('label11') },
        { id: 12, src: Img32, category: 'Fachadas', labelKey: t('label12') },
        { id: 13, src: Img5, category: 'Fachadas', labelKey: t('label13') },
        { id: 14, src: Img33, category: 'Fachadas', labelKey: t('label14') },
        { id: 15, src: Img31, category: 'Fachadas', labelKey: t('label15') },
        { id: 16, src: Img16, category: 'Piscinas', labelKey: t('label16') },
        { id: 17, src: Img12, category: 'Piscinas', labelKey: t('label17') },
        { id: 18, src: Img27, category: 'Piscinas', labelKey: t('label18') },
        { id: 19, src: Img28, category: 'Piscinas', labelKey: t('label19') },
        { id: 20, src: Img38, category: 'Piscinas', labelKey: t('label20') },
    ];

    const filteredImages = selectedCategory === 'Todas'
        ? images
        : images.filter(img => img.category === selectedCategory);

    return (
        <div className="rn-team-area ptb--60 bg_color--1">
            <div className="gallery">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title service-style--3 text-center mb--60 mb_sm--0">
                            <h2 className="title3">{t('GalleryTitle')}</h2>
                        </div>
                    </div>
                </div>

                <div className="gallery-categories">
                    {categories.map(({ key, label }) => (
                        <button
                            key={key}
                            className={`category-button ${selectedCategory === key ? 'active' : ''}`}
                            onClick={() => setSelectedCategory(key)}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                <div className="gallery-layout">
                    <div className="gallery-left">
                        {filteredImages[0] && (
                            <div className="gallery-item-hover">
                                <img src={filteredImages[0].src} alt="" className="gallery-image large" />
                                <div className="gallery-hover-label">{t(`${filteredImages[0].labelKey}`)}</div>
                            </div>
                        )}
                    </div>

                    <div className="gallery-right">
                        <div className="gallery-top">
                            {filteredImages[1] && (
                                <div className="gallery-item-hover">
                                    <img src={filteredImages[1].src} alt="" className="gallery-image small" />
                                    <div className="gallery-hover-label">{t(`${filteredImages[1].labelKey}`)}</div>
                                </div>
                            )}
                            {filteredImages[2] && (
                                <div className="gallery-item-hover">
                                    <img src={filteredImages[2].src} alt="" className="gallery-image small" />
                                    <div className="gallery-hover-label">{t(`${filteredImages[2].labelKey}`)}</div>
                                </div>
                            )}
                        </div>

                        <div className="gallery-bottom">
                            {filteredImages[3] && (
                                <div className="gallery-item-hover">
                                    <img src={filteredImages[3].src} alt="" className="gallery-image medium" />
                                    <div className="gallery-hover-label">{t(`${filteredImages[3].labelKey}`)}</div>
                                </div>
                            )}
                            {filteredImages[4] && (
                                <div className="gallery-item-hover">
                                    <img src={filteredImages[4].src} alt="" className="gallery-image medium" />
                                    <div className="gallery-hover-label">{t(`${filteredImages[4].labelKey}`)}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
